import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateContractorCompany = () => {
  const mutation = useMutation((name) => {
    return axiosClient.post("/CompanyContractor/CreateCompanyContractor", { name });
  });
  return mutation;
};
export default useCreateContractorCompany;
